export default function shouldRetryFetch(error) {
  // Retry if the error is a network error or a 5xx server error
  return error.message === 'Network Error'
         || (error.response && error.response.status >= 500 && error.response.status < 600);
}
